/* eslint-disable react/prop-types */
/*
Author: Gilang Romadhanu Tartila
*/

import React, { useState, useEffect } from 'react';
import * as Layout from '@components/screen/Layout';
import InputClickCallback from '@components/form/InputClickCallback';

const SelectFormRulesMobile = ({
  type = 'sales_team', // type of search
  typeValue = '', // specific value type
  data = [], // data list based on type
  labelValue = '', // result value in input text based on type
  stepModal = 1, // step form picker popup based on type
  setStepModal, // change step callback
  setShowRules, // show popup callback
  setRulesType, // change specific value type callback
  setSelected = () => {}, // set selected value callback
}) => {
  const [title, setTitle] = useState('');

  useEffect(() => {
    let mounted = true;
    if (mounted && stepModal == 1) {
      if (type == 'sales_team') {
        setTitle('Sales Team');
      } else if (type == 'customer') {
        setTitle('Customers');
      } else if (type == 'product') {
        setTitle('Product');
      }
    }
    return () => {
      mounted = false;
    };
  }, [stepModal]);

  return (
    <>
      <Layout.FormGroup>
        <InputClickCallback
          label={title}
          value={data}
          trackBy="id"
          labelKey="name"
          labelValue={labelValue}
          onClick={() => {
            setStepModal(1);
            setShowRules(type);
            setRulesType(typeValue);
          }}
          onChange={(val) => {
            setSelected({ type: typeValue, value: val });
          }}
        />
      </Layout.FormGroup>
    </>
  );
};

export default SelectFormRulesMobile;
